import { apiClient } from "./apiClient";

/**
 * JIT (just-in-time) admin access requests -- wired to the real routes in
 * api/functions/admin.py. Being in the B2C admin group (api/services/auth.py's
 * _is_admin) is necessary but not sufficient for a growing set of sensitive
 * admin routes: the caller also needs an active, second-admin-approved
 * app.JITAccessRequests grant. create/myStatus don't require an existing
 * grant (a requester can't have one yet -- that's what they're requesting);
 * listPending/decide do (reviewing/approving is itself sensitive) and will
 * 403 with { error: "jit_access_required" } if the caller lacks one -- see
 * apiClient.js's response interceptor and AuthContext.jsx's `jitRequired`
 * for how that routes the app back to AccessRequestPage.
 *
 * The two consumers are AccessRequestPage.jsx (create/myStatus, the
 * requester-facing half) and ReviewAccessRequestsPage.jsx (listPending/decide,
 * the approver-facing half).
 *
 * BOOTSTRAP NOTE: the very first admin has no grant and nobody can approve
 * them through this UI yet (chicken-and-egg, same as any real JIT system) --
 * that one must be seeded directly in app.JITAccessRequests (status =
 * 'Approved', a far-future expires_at) by whoever deploys this.
 */
export const accessRequestApi = {
  create: (reason, requestedMinutes) =>
    apiClient.post("/management/access-requests", { reason, requested_minutes: requestedMinutes }).then((r) => r.data),

  myStatus: () => apiClient.get("/management/access-requests/mine").then((r) => r.data),

  listPending: () => apiClient.get("/management/access-requests", { params: { status: "Pending" } }).then((r) => r.data),

  decide: (requestId, approve, denialReason) =>
    apiClient.post(`/management/access-requests/${requestId}/decision`, { approve, denial_reason: denialReason }).then((r) => r.data),
};
